import React from 'react'

import { Column } from 'primereact/column'

import { PanelContainer } from '../../../../components/Panel'
import {
  AttachmentDownloadButton,
  AttachmentOpenInTabButton,
} from '../../../../components/attachments'
import {
  Attachment as AttachmentModel,
  WebEdiDto,
} from '../../../../data/models'
import { getConfigTranslation } from '../../../../utils/helper/getConfigTranslation'
import { ConfigurableTable } from '../../../../utils/wrapper'
import { useConfigContext } from '../../../ui-config/context'
import { useInvoiceById } from '../../data'
import { AttachmentWithStatus } from '../../data/model'
import {
  InfoAttachmentDialog,
  UploadAttachmentDialogContainer,
} from './dialogs'
import { DeleteAttachmentDialog } from './dialogs/delete'

interface Props {
  invoiceId: WebEdiDto['Id']
  processId: string
}

export const Attachment: React.FC<Props> = ({ invoiceId, processId }) => {
  const { data: invoice, isLoading } = useInvoiceById(invoiceId)
  const { uiConfig: config } = useConfigContext()

  const actionBodyTemplate = (rowData: AttachmentModel) => {
    return (
      <>
        <DeleteAttachmentDialog
          key={`att-delete-${rowData.Id}`}
          attachmentId={rowData.Id}
          attachmentUrl={rowData.Url as string}
          attachmentName={rowData.Name}
          invoiceId={invoiceId}
        />

        <AttachmentOpenInTabButton
          key={`att-tab-${rowData.Id}`}
          fullUrl={rowData.Url as string}
          mimeType={rowData.MimeType as string}
          fileName={rowData.Name}
        />

        <AttachmentDownloadButton
          key={`att-download-${rowData.Id}`}
          fullUrl={rowData.Url as string}
          mimeType={rowData.MimeType as string}
          fileName={rowData.Name}
        />

        {rowData.Category === 'aiInvoiceDocument' && <InfoAttachmentDialog />}
      </>
    )
  }

  const headerActions = (
    <>
      {config.invoice.uploadAttachment.enabled !== false && (
        <UploadAttachmentDialogContainer
          invoiceId={invoiceId}
          processId={processId}
        />
      )}
    </>
  )

  const attachmentButtons = (
    <Column
      key="attachmentButtons"
      body={actionBodyTemplate}
      align="right"
    ></Column>
  )

  // Get data for attachments
  const newAttachments = invoice?.Attachments?.filter(
    item => item.Type.toLowerCase() === 'additional',
  )?.map(attachment => attachment as AttachmentWithStatus)

  newAttachments?.forEach(attachment => {
    if (attachment?.Category === 'aiInvoiceDocument') {
      attachment.Status = invoice?.Payload.AiAnalysisResult?.Status
    }
  })

  return (
    <PanelContainer
      header={getConfigTranslation(config.invoice.attachment.title)}
      id="invoice-attachment"
      visible={config.invoice.attachment.enabled}
    >
      <ConfigurableTable
        config={config.invoice.attachment.additionalDocuments}
        data={newAttachments}
        headerActions={headerActions}
        buttons={attachmentButtons}
        isLoading={isLoading}
        stateKey=""
      />
    </PanelContainer>
  )
}
